export const ChartDefaultColors = ["#1976d2", "#2e7d32", "#ed6c02", "#9c27b0", "#d32f2f"];
